import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {WhiteCrossOutlined} from '@jobseeker/lotus/icons';
import {PropTypes} from '../type';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  '& .MuiDialog-paper': {
    position: 'absolute',
    top: 0,
    margin: 0,
    marginRight: 2,
    marginLeft: 2,
    height: 'auto',
    width: isAppIimjobs ? 'calc(100% - 32px)' : 'calc(100% - 60px)',
    maxHeight: 'calc(100vh - 64px)',
    maxWidth: 'calc(100vw - 32px)',
    overflowX: 'auto',
    overflowY: 'auto',
    borderBottomLeftRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    [theme.breakpoints.down(1400)]: {
      marginRight: 1,
      marginLeft: 1,
      height: 'auto',
      width: 'calc(100% - 16px)',
      maxHeight: 'calc(100vh - 64px)',
      maxWidth: 'calc(100vw - 16px)',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      margin: 0,
      borderRadius: 0,
    },
  },

  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    overflowX: 'auto',
    overflowY: 'auto',
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  [theme.breakpoints.down('md')]: {
    '& .MuiDialog-paper': {
      width: '100vw',
    },
  },
}));

const Component = ({title, subtitle, invertedTitle, ...props}: PropTypes) => {
  const handleClose = (event: any) => {
    if (props.onClose) props.onClose(event, 'escapeKeyDown');
  };
  const isLarge = useIsLargeDevice();
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  return (
    <div>
      <BootstrapDialog {...props} fullWidth={true} maxWidth={false}>
        {isAppIimjobs && (
          <Box
            sx={{
              height: 66,

              position: 'relative',
              background: !isAppIimjobs
                ? '#fff'
                : 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
              pr: 6,
              borderBottomLeftRadius: '12px',
              borderBottomRightRadius: '12px',
              boxShadow: !isAppIimjobs
                ? '0px 4px 10px rgba(0, 0, 0, 0.1)'
                : 'none',
            }}
          >
            <DialogTitle marginTop={0} paddingTop={0}>
              <>
                <Typography
                  color={!isAppIimjobs ? 'black' : 'primary.contrastText'}
                  fontSize={18}
                  fontWeight={500}
                >
                  {title}
                </Typography>
              </>
            </DialogTitle>
            <Box
              sx={{
                position: 'absolute',
                right: 8,
                zIndex: 1,
                top: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                <div style={{filter: isAppIimjobs ? 'none' : 'invert(1)'}}>
                  <Image
                    width={18}
                    height={18}
                    src={WhiteCrossOutlined}
                    alt={'white cross'}
                    style={{fill: 'black'}}
                  />
                </div>
              </IconButton>
            </Box>
          </Box>
        )}
        <DialogContent
          sx={{
            marginTop: 3,
            marginLeft: {xl: 8.75},
            marginRight: {xl: 8.75},

            borderBottomLeftRadius: 2,
            borderBottomRightRadius: 2,
          }}
        >
          {props.children}
        </DialogContent>
        {props.footer}
      </BootstrapDialog>
    </div>
  );
};

export default Component;
